const AttributionPage = () => {
    return (
        <div className='h-lvh flex flex-col justify-center items-center text-center'>
            <h2 className='text-xl'>Made by <a className='font-bold primary-color hover:text-yellow-600' href='https://www.linkedin.com/in/jadharmoush/'>Jad Harmoush</a></h2>
            <p>THANKS FOR CHECKING :)</p>
        </div>
    )
}

export default AttributionPage;